// extracted by mini-css-extract-plugin
export default {"card":"SoundItem_card__gKdjq","cardContrast":"SoundItem_cardContrast__0o9HL","button":"SoundItem_button__litBD","buttonContrast":"SoundItem_buttonContrast__EjHX2"};